import { useFormik } from "formik";
import React, { useState } from "react";
import { Col, Container, Form, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import * as Yup from "yup";
import { BlurSpinner } from "../../components/BlurSpinner";
import SpinnerButton from "../../components/Button";
import TicketZoneSelector from "../../components/TicketZoneSelector";

const DerivarModal = ({ toggle, ticket, isSavingTicket, handleTicketSave }) => {
  const [spinnerState, setSpinnerState] = useState(true);
  const ticketZoneMount = () => {
    setSpinnerState(false);
  };

  const formik = useFormik({
    initialValues: {
      asignacion2: ticket.asignacion2,
      sucursaldepartamentoAsignado: ticket.sucursaldepartamentoAsignado,
      motivo: ticket.motivo2,
      submotivo: ticket.submotivo,
    },
    onSubmit: async (data) => {
      formik.setSubmitting(true);
      try {
        await handleTicketSave(data, { formik });
        // eslint-disable-next-line no-empty
      } catch (err) {}
      formik.setSubmitting(false);
    },
    validationSchema: Yup.object().shape({
      asignacion2: Yup.number().typeError("Debe seleccionar un sector de la lista").required("Este campo es requerido."),
      sucursaldepartamentoAsignado: Yup.mixed().when("asignacion2", (asignacion2) => {
        if (asignacion2 === 1) {
          return Yup.number().typeError("Debe seleccionar un departamento de la lista").required("Este campo es requerido.");
        }
        if (asignacion2 === 2) {
          return Yup.number().typeError("Debe seleccionar una sucursal de la lista").required("Este campo es requerido.");
        }
        return Yup.mixed().required("Este campo es requerido.");
      }),
      motivo: Yup.number().typeError("Debe seleccionar un motivo de la lista").required("Este campo es requerido."),
      submotivo: Yup.number().typeError("Debe seleccionar un sub motivo de la lista").required("Este campo es requerido."),
    }),
  });

  return (
    <Modal centered backdrop="static" isOpen toggle={toggle}>
      <Form onSubmit={formik.handleSubmit}>
        <ModalHeader toggle={toggle}> Derivar el ticket </ModalHeader>
        <BlurSpinner isLoading={spinnerState}>
          <ModalBody style={{ borderRadius: "10px", minHeight: "250px" }}>
            <Container fluid>
              <Row>
                <Col className="h-100">
                  <TicketZoneSelector formik={formik} typeMotivo={false} mounted={ticketZoneMount} />
                </Col>
              </Row>
            </Container>
          </ModalBody>
          <ModalFooter>
            <FormGroup className="mb-0 px-3">
              <SpinnerButton className="btn btn-primary btn-block" isLoading={isSavingTicket} disabled={isSavingTicket} type="submit">
                Derivar
              </SpinnerButton>
            </FormGroup>
          </ModalFooter>
        </BlurSpinner>
      </Form>
    </Modal>
  );
};

export default DerivarModal;
